import _ from 'lodash';
import moment from 'moment';
import qs from 'query-string';
import React, { useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';

import Switch from '../../../../components/Button/Switch';
import Modal from '../../../../components/Modal';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { POST, PUT, newFetch } from '../../../../helpers/fetch';
import {
  to12Hr,
  toWeekEndDate,
  toWeekStartDate,
} from '../../../../helpers/moment';

const Shifts = ({
  history,
  location: { search },
  activeDate,
  activeClient,
  activeSite,
  activeShifts,
  activeShift,
  setActiveShift,
  fetchShifts,
  fetchSchedules,
  activeWeek,
  activeSchedules,
  setRefreshCalendar,
  setAssocCheckedItems,
  rewardReasons,
  todayAttendanceRate,
  attendanceRates,
  activeWeekRate,
  setShowShiftSlotModal,
  setSelectedShiftForUpdateSlot,
  setNewShiftSlot,
  currentWeek,
  todayFillRate,
  fillRates,
  fetchScheduleAssociates,
  setShowModalShifts,
  showModalShifts,
  sites = [],
  selectedSiteID,
}) => {
  const params = qs.parse(search);
  const type = localStorage.getItem('type');
  const allSitesSelected = Number(selectedSiteID) === 0;
  const selectedSite =
    sites.find((site) => Number(site.id) === Number(selectedSiteID)) ||
    activeSite;
  const targetSites = allSitesSelected
    ? sites
    : selectedSite
    ? [selectedSite]
    : [];

  const padding = 90; // adjust this to your needs
  let height = 450 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: 'auto', // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '40%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '100%',
    maxWidth: '55rem',
  };

  // const [showModal, setShowModal] = useState(false);
  const [shiftName, setShiftName] = useState('');
  const [shiftStartTime, setShiftStartTime] = useState('');
  const [shiftEndTime, setShiftEndTime] = useState('');
  const [toggledItems, setToggledItems] = useState([]);

  const toggleItem = async (isToggled, id, index) => {
    const weekRange = `${activeWeek.startDate.format(
      'MMM DD'
    )} - ${activeWeek.endDate.format('DD')}`;
    let items = [...toggledItems];
    const shift = activeShifts.filter((shift) => shift.id === id);
    const confirmMessage = `Are you sure you want to switch ${
      isToggled ? 'On' : 'Off'
    } this shift <strong>'${_.head(shift).name}'</strong> ?`;

    if (isToggled) {
      const isConfirmed = await AlertService.confirm('', confirmMessage);
      if (isConfirmed) {
        items = [...items, id];
      } else {
        return false;
      }
    } else {
      const isConfirmedOff = await AlertService.confirm(
        '',
        `${confirmMessage} <br /><br /><div class="alert alert-info" role="alert"><strong>Note:</strong> All records will be deleted such as assigned shift, preferred shifts and fixed schedule.</div>`
      );
      if (isConfirmedOff) {
        items = [...items.filter((item) => item !== id)];
      } else {
        return false;
      }
    }

    await updateShiftStatus(
      id,
      isToggled,
      activeWeek.startDate.format('YYYY-MM-DD'),
      index
    );
    setToggledItems(items);
  };

  const saveWeekdayOrEnd = async (weekdayOrEnd, value, shiftId, index) => {
    let data = {};
    if (weekdayOrEnd === 'wkday') {
      data = {
        wkday_reward_reason_id: value,
      };
    }

    if (weekdayOrEnd === 'wkend') {
      data = {
        wkend_reward_reason_id: value,
      };
    }

    if (weekdayOrEnd === 'sort') {
      data = {
        sort: value,
      };
    }

    const api_path = `/shifts/${shiftId}/wkreward/status`;
    const response = await newFetch(PUT, api_path, data);

    if (response.success) {
      ToastUtil.success('Update shift successfully.');
      if (weekdayOrEnd === 'wkday') {
        activeShifts[index].wkday_reward_reason_id = JSON.parse(value);
      }
      if (weekdayOrEnd === 'wkend') {
        activeShifts[index].wkend_reward_reason_id = JSON.parse(value);
      }
      if (weekdayOrEnd === 'sort') {
        activeShifts[index].sort = value;
      }
    }
  };

  const isNumeric = (value) => /^-?\d+$/.test(value);

  const saveShiftSorting = async (value, shiftId, index) => {
    if (isNumeric(value) && value >= 1) {
      const api_path = `/shifts/${shiftId}/wkreward/status`;
      const response = await newFetch(PUT, api_path, {
        sort: value,
      });

      if (response.success) {
        ToastUtil.success('Update shift sort successfully.');

        activeShifts[index].sort = value;
      }
    } else {
      ToastUtil.error('Invalid selected sort value, Please try again.');
    }
  };

  const debounceFn = useCallback(_.debounce(saveShiftSorting, 800), [
    activeShifts,
  ]);

  const handleChange = (event, shiftId, index) => {
    debounceFn(event.target.value, shiftId, index);
  };

  const saveShiftName = async (value, shiftId, index) => {
    if (value) {
      const api_path = `/shifts/${shiftId}/wkreward/status`;
      const response = await newFetch(PUT, api_path, {
        name: value,
      });

      if (response.success) {
        ToastUtil.success('Update shift name successfully.');

        activeShifts[index].name = value;
      }
    } else {
      ToastUtil.error('Invalid selected name value, Please try again.');
    }
  };

  const debounceFnName = useCallback(_.debounce(saveShiftName, 800), [
    activeShifts,
  ]);

  const handleChangeName = (event, shiftId, index) => {
    debounceFnName(event.target.value, shiftId, index);
  };

  const updateShiftStatus = async (shiftId, status, date, index) => {
    closeModal();
    const shift = activeShifts.find((item) => item.id === shiftId);
    const shiftSiteId = Number(shift?.site_id || selectedSite?.id);

    if (!shiftSiteId) {
      ToastUtil.error('Unable to identify the shift site.');
      return false;
    }

    let api_path = `/shifts/${shiftId}/status`;
    let response = await newFetch(PUT, api_path, {
      site_id: shiftSiteId,
      status: status,
      date: date,
    });

    if (response.success) {
      await fetchShifts(allSitesSelected ? 0 : shiftSiteId);
      await fetchSchedules(allSitesSelected ? 0 : shiftSiteId);
      ToastUtil.success(response.message);
    }
    return true;
  };

  const closeModal = () => {
    setShowModalShifts(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (shiftName && shiftStartTime && shiftEndTime) {
      if (targetSites.length === 0) {
        ToastUtil.error('No available sites selected.');
        return;
      }

      const isConfirmed = await AlertService.confirm(
        '',
        `Are you sure you want to add this shift to ${
          allSitesSelected
            ? `all ${targetSites.length} available sites`
            : targetSites[0].name
        }? <br /><br /><div class="alert alert-info" role="alert"><strong>Note:</strong> Newly added shift will be reflected starting today.</div>`
      );
      if (isConfirmed) {
        let data = {
          name: shiftName,
          start_time: shiftStartTime,
          end_time: shiftEndTime,
          client_id: activeClient.id,
          site_ids: targetSites.map((site) => site.id),
        };

        try {
          const targetSiteID = allSitesSelected ? 0 : targetSites[0].id;
          let api_path = `/site/${targetSiteID}/shifts`;
          let response = await newFetch(POST, api_path, data);

          if (response.success) {
            const createdShifts = allSitesSelected
              ? response.data?.created || []
              : [response.data];
            const currentWeekStartDate = toWeekStartDate(
              moment(),
              activeClient.start_day
            );
            const currentWeekEndDate = toWeekEndDate(
              moment(),
              activeClient.start_day
            );
            const currentDate = moment().format('YYYY-MM-DD');
            const scheduleResponses = await Promise.all(
              createdShifts.map(async (shift) => {
                const site = targetSites.find(
                  (targetSite) => Number(targetSite.id) === Number(shift.site_id)
                );

                if (!site || site.enable_br_upload !== false) return null;

                return newFetch(POST, `/site/${site.id}/schedule/create`, {
                  start_date: moment(currentWeekStartDate).format('YYYY-MM-DD'),
                  end_date: moment(currentWeekEndDate).format('YYYY-MM-DD'),
                  activeDate: currentDate,
                  shift_id: shift.id,
                });
              })
            );
            const failedSchedules = scheduleResponses.filter(
              (scheduleResponse) =>
                scheduleResponse && scheduleResponse.success === false
            );

            ToastUtil.success(response.message);
            if (failedSchedules.length > 0) {
              ToastUtil.error(
                `Shift created, but ${failedSchedules.length} site schedule(s) could not be generated.`
              );
            }

            await fetchShifts(allSitesSelected ? 0 : targetSites[0].id);
            await fetchSchedules(allSitesSelected ? 0 : targetSites[0].id);
            setShowModalShifts(false);
          } else {
            ToastUtil.error(response.message);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      ToastUtil.error('Please check input fields.');
    }
  };

  const handleChangeShift = (shift_id) => {
    setActiveShift(shift_id);
    setAssocCheckedItems([]);

    fetchScheduleAssociates(activeSite.id, activeSchedules, shift_id);

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        shift: shift_id,
      }),
    });
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%' }}>
      <div
        className=""
        style={{ flexDirection: 'column', justifyContent: 'flex-start' }}
      >
        <div>
          {activeClient &&
            targetSites.length > 0 &&
            type !== 'client' &&
            moment(activeWeek.startDate).isSameOrAfter(
              toWeekStartDate(moment(), activeClient.start_day).subtract(
                1,
                'days'
              )
            ) && (
              <React.Fragment>
                <Modal
                  showModal={showModalShifts}
                  customStyle={style}
                  hideModal={closeModal}
                >
                  <div className="h-100">
                    <form
                      className="d-flex flex-column justify-content-between flex-grow-1 mb-3"
                      onSubmit={(e) => submitHandler(e)}
                    >
                      <h5>Manage Shift</h5>
                      <div className="mb-2">
                        <label htmlFor="shiftName">Shift Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="shiftName"
                          placeholder="Shift Name"
                          value={shiftName}
                          onChange={(e) => setShiftName(e.target.value)}
                        />
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="mb-2">
                            <label htmlFor="shiftStartTime">
                              Shift Start Time
                            </label>
                            <input
                              type="time"
                              className="form-control"
                              id="shiftStartTime"
                              onChange={(e) =>
                                setShiftStartTime(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col">
                          <div className="mb-2">
                            <label htmlFor="shiftEndTime">Shift End Time</label>
                            <input
                              type="time"
                              className="form-control"
                              id="shiftEndTime"
                              onChange={(e) => setShiftEndTime(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end mt-auto pt-3">
                        <button
                          type="button"
                          onClick={() => setShowModalShifts(false)}
                          className="btn btn-outline-brand"
                          style={{ width: '12rem' }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-brand ms-3"
                          style={{ width: '12rem' }}
                        >
                          Add Shift
                        </button>
                      </div>
                    </form>
                    <div
                      className="mb-2"
                      style={{
                        marginTop: 25,
                      }}
                    >
                      <div
                        className="row"
                        style={{
                          fontSize: 14,
                        }}
                      >
                        <div className="col-2 text-center">
                          {allSitesSelected ? 'Shift / Site' : 'Shifts Name'}
                        </div>
                        <div className="col-2 text-center">Time</div>
                        <div className="col-2 text-center">Active</div>
                        {activeClient?.enable_reward ? (
                          <>
                            <div
                              className="col-2"
                              style={{
                                alignItems: 'center',
                              }}
                            >
                              Weekday (Reward)
                            </div>
                            <div
                              className="col-2"
                              style={{
                                alignItems: 'center',
                              }}
                            >
                              Weekend (Reward)
                            </div>
                            <div
                              className="col-1 text-center"
                              style={{
                                alignItems: 'center',
                              }}
                            >
                              Sort
                            </div>
                          </>
                        ) : (
                          <div
                            className="col-5 text-center"
                            style={{
                              alignItems: 'center',
                            }}
                          >
                            Sort
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="mb-2"
                      style={{
                        height: '250px',
                        overflow: 'hidden scroll',
                      }}
                    >
                      {/* Iterate switch on shift */}
                      {activeShifts
                        .filter((item) => item.status && item)
                        .sort((a, b) => a.sort - b.sort)
                        .map((shift, index) => (
                          <div
                            key={shift.id}
                            className="row manage-shift-wrapper"
                            style={{
                              height: allSitesSelected ? '50px' : '35px',
                              marginBottom: 10,
                            }}
                          >
                            <div className="col-3">
                              <input
                                type="text"
                                className="form-control"
                                name={`name${shift.id}`}
                                // id={`name-${shift.id}`}
                                disabled={!shift.status}
                                style={{
                                  width: 180,
                                }}
                                onChange={(e) => {
                                  handleChangeName(e, shift.id, index);
                                }}
                                defaultValue={
                                  shift.name ? shift.name : 'Unknown'
                                }
                              />
                              {allSitesSelected && (
                                <div className="small text-muted mt-1">
                                  {shift.site_name}
                                </div>
                              )}
                            </div>

                            {/* <div className="col-3">
                              <div key={shift.id} className="me-2">
                                <div className="mb-2" style={{ fontSize: 12 }}>
                                  {shift.name ? shift.name : 'Unknown'}{' '}
                                </div>
                              </div>
                            </div> */}

                            <div className="col-2">
                              <div key={shift.id} className="me-2">
                                <div className="mb-2" style={{ fontSize: 12 }}>
                                  {to12Hr(shift.start_time)} -{' '}
                                  {to12Hr(shift.end_time)}
                                </div>
                              </div>
                            </div>

                            <div className="col-2 d-flex justify-content-center">
                              <Switch
                                isOn={shift.status}
                                onColor="#2d5fa4"
                                shiftId={shift.id}
                                handleToggle={(e) => {
                                  toggleItem(e.target.checked, shift.id, index);
                                }}
                              />
                            </div>

                            {activeClient?.enable_reward ? (
                              <>
                                <div className="col-2">
                                  <select
                                    name={`wkdayRewardReasonID-${shift.id}`}
                                    id={`wkdayRewardReasonID-${shift.id}`}
                                    className="form-select ms-2"
                                    disabled={!shift.status}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      saveWeekdayOrEnd(
                                        'wkday',
                                        e.target.value,
                                        shift.id,
                                        index
                                      );
                                    }}
                                    defaultValue={shift.wkday_reward_reason_id}
                                  >
                                    <option value={0}> </option>
                                    {rewardReasons &&
                                      rewardReasons.length > 0 &&
                                      rewardReasons
                                        .filter(
                                          (item) =>
                                            item.active === true &&
                                            item.deletedAt === null
                                        )
                                        .map((rewardReason) => (
                                          <option
                                            key={rewardReason.id}
                                            value={rewardReason.id}
                                          >
                                            {rewardReason.reason}
                                          </option>
                                        ))}
                                  </select>
                                </div>

                                <div className="col-2">
                                  <select
                                    name={`wkdendRewardReasonID-${shift.id}`}
                                    id={`wkdendRewardReasonID-${shift.id}`}
                                    className="form-select ms-2"
                                    disabled={!shift.status}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      saveWeekdayOrEnd(
                                        'wkend',
                                        e.target.value,
                                        shift.id,
                                        index
                                      );
                                    }}
                                    defaultValue={shift.wkend_reward_reason_id}
                                  >
                                    <option value={0}> </option>
                                    {rewardReasons &&
                                      rewardReasons.length > 0 &&
                                      rewardReasons
                                        .filter(
                                          (item) =>
                                            item.active === true &&
                                            item.deletedAt === null
                                        )
                                        .map((rewardReason) => (
                                          <option
                                            key={rewardReason.id}
                                            value={rewardReason.id}
                                          >
                                            {rewardReason.reason}
                                          </option>
                                        ))}
                                  </select>
                                </div>
                                <div className="col-1 d-flex justify-content-center">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={`sort${shift.id}`}
                                    id={`sort-${shift.id}`}
                                    disabled={!shift.status}
                                    style={{
                                      width: 50,
                                    }}
                                    onChange={(e) => {
                                      handleChange(e, shift.id, index);
                                    }}
                                    defaultValue={shift.sort}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="col-5 d-flex justify-content-center">
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`sort${shift.id}`}
                                  id={`sort-${shift.id}`}
                                  disabled={!shift.status}
                                  style={{
                                    width: 50,
                                  }}
                                  onChange={(e) => {
                                    handleChange(e, shift.id, index);
                                  }}
                                  defaultValue={shift.sort}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      {/* Iterate switch off shift */}
                      {activeShifts
                        .filter((item) => !item.status && item)
                        .sort((a, b) => a.sort - b.sort)
                        .map((shift, index) => (
                          <div
                            key={shift.id}
                            className="row manage-shift-wrapper"
                            style={{
                              height: allSitesSelected ? '50px' : '35px',
                              marginBottom: 10,
                            }}
                          >
                            <div className="col-3">
                              <input
                                type="text"
                                className="form-control"
                                name={`name${shift.id}`}
                                // id={`name-${shift.id}`}
                                disabled={!shift.status}
                                style={{
                                  width: 180,
                                }}
                                onChange={(e) => {
                                  handleChangeName(e, shift.id, index);
                                }}
                                defaultValue={
                                  shift.name ? shift.name : 'Unknown'
                                }
                              />
                              {allSitesSelected && (
                                <div className="small text-muted mt-1">
                                  {shift.site_name}
                                </div>
                              )}
                            </div>
                            {/* <div className="col-3">
                              <div key={shift.id} className="me-2">
                                <div className="mb-2" style={{ fontSize: 12 }}>
                                  {shift.name ? shift.name : 'Unknown'}{' '}
                                </div>
                              </div>
                            </div> */}
                            <div className="col-2">
                              <div key={shift.id} className="me-2">
                                <div className="mb-2" style={{ fontSize: 12 }}>
                                  {to12Hr(shift.start_time)} -{' '}
                                  {to12Hr(shift.end_time)}
                                </div>
                              </div>
                            </div>

                            <div className="col-2 d-flex justify-content-center">
                              <Switch
                                isOn={shift.status}
                                onColor="#2d5fa4"
                                shiftId={shift.id}
                                handleToggle={(e) => {
                                  toggleItem(e.target.checked, shift.id, index);
                                }}
                              />
                            </div>

                            {activeClient?.enable_reward ? (
                              <>
                                <div className="col-2">
                                  <select
                                    name={`wkdayRewardReasonID-${shift.id}`}
                                    id={`wkdayRewardReasonID-${shift.id}`}
                                    className="form-select ms-2"
                                    disabled={!shift.status}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      saveWeekdayOrEnd(
                                        'wkday',
                                        e.target.value,
                                        shift.id,
                                        index
                                      );
                                    }}
                                    defaultValue={shift.wkday_reward_reason_id}
                                  >
                                    <option value={0}> </option>
                                    {rewardReasons &&
                                      rewardReasons.length > 0 &&
                                      rewardReasons
                                        .filter(
                                          (item) =>
                                            item.active === true &&
                                            item.deletedAt === null
                                        )
                                        .map((rewardReason) => (
                                          <option
                                            key={rewardReason.id}
                                            value={rewardReason.id}
                                          >
                                            {rewardReason.reason}
                                          </option>
                                        ))}
                                  </select>
                                </div>

                                <div className="col-2">
                                  <select
                                    name={`wkdendRewardReasonID-${shift.id}`}
                                    id={`wkdendRewardReasonID-${shift.id}`}
                                    className="form-select ms-2"
                                    disabled={!shift.status}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      saveWeekdayOrEnd(
                                        'wkend',
                                        e.target.value,
                                        shift.id,
                                        index
                                      );
                                    }}
                                    defaultValue={shift.wkend_reward_reason_id}
                                  >
                                    <option value={0}> </option>
                                    {rewardReasons &&
                                      rewardReasons.length > 0 &&
                                      rewardReasons
                                        .filter(
                                          (item) =>
                                            item.active === true &&
                                            item.deletedAt === null
                                        )
                                        .map((rewardReason) => (
                                          <option
                                            key={rewardReason.id}
                                            value={rewardReason.id}
                                          >
                                            {rewardReason.reason}
                                          </option>
                                        ))}
                                  </select>
                                </div>
                                <div className="col-1 d-flex justify-content-center">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={`sort${shift.id}`}
                                    id={`sort-${shift.id}`}
                                    disabled={!shift.status}
                                    style={{
                                      width: 50,
                                    }}
                                    onChange={(e) => {
                                      handleChange(e, shift.id, index);
                                    }}
                                    defaultValue={shift.sort}
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="col-5 d-flex justify-content-center">
                                <input
                                  type="text"
                                  className="form-control"
                                  name={`sort${shift.id}`}
                                  id={`sort-${shift.id}`}
                                  disabled={!shift.status}
                                  style={{
                                    width: 50,
                                  }}
                                  onChange={(e) => {
                                    handleChange(e, shift.id, index);
                                  }}
                                  defaultValue={shift.sort}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </Modal>
              </React.Fragment>
            )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Shifts);
